export default "__VITE_ASSET__d80eba04__"